import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { intlShape, injectIntl } from 'react-intl';
import {
  Modal,
  ModalButtons,
  ModalContent,
  ProgressBar,
  Label,
  withForm,
} from 'mw-style-react';
import AppUtils from '@control-front-end/utils/utils';
import { REQUEST_ACCESS } from 'constants';
import mes from './intl';
import '../../Modal.scss';

class RequestAccess extends PureComponent {
  // Ф-ция локализации
  i(mesId, values) {
    return AppUtils.getMes(this.context)(mesId, values);
  }

  render() {
    const { visibility, onClose, isSubmit, data } = this.props;

    return (
      <Modal
        visibility={visibility}
        onClose={onClose}
        label={this.i(mes.needPerm)}
      >
        <ModalContent styleName="modal__content">
          <Label
            value={`${this.i(mes.wantAccess)} (${data.config.supportEmail})`}
          />
          <br />
          <br />
          <Label value={`${this.i(mes.youAreSignIn)}`} />
          &nbsp;
          <b>{data.auth.login}</b>
        </ModalContent>
        <ModalButtons>
          <ProgressBar
            styleName="modal__loader"
            type="circle"
            size="small"
            visibility={isSubmit ? 'visible' : 'hidden'}
          />
        </ModalButtons>
      </Modal>
    );
  }
}

const FormInvite = withForm(
  {
    handleSubmit: (values, dispatch, formActions, props) => {
      formActions.onClose = props.onClose;
      dispatch({
        type: REQUEST_ACCESS.REQUEST,
        payload: {
          body: {
            email: props.data.auth.login,
            userName: props.data.auth.nick,
          },
          formActions,
        },
      });
    },
  },
  RequestAccess
);

RequestAccess.propTypes = {
  visibility: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  isSubmit: PropTypes.bool,
  data: PropTypes.object,
};

RequestAccess.contextTypes = {
  intl: intlShape,
};

export default injectIntl(FormInvite);
